import axios from 'axios';
import { i18n } from 'vue-lang-router';

const apiUrl = process.env.VUE_APP_API_SUPPORT_URL;
const LATEST_MATERIALS_PER_PAGE = 10;

export default {
  state: {
    featuredMaterials: null,
    featuredMaterialsLoading: false,
    topRatedMaterials: null,
    topRatedMaterialsLoading: false,
    mostVisitedMaterials: null,
    mostVisitedMaterialsLoading: false,
    mostCommentedMaterials: null,
    mostCommentedMaterialsLoading: false,
    latestMaterials: null,
    latestMaterialsLoadingMore: false,
    latestMaterialsCurrentPage: 1,
    latestMaterialsTotalPages: null,
    latestMaterialsReachedTheEnd: false,
    recentCommentCompetitionMaterials: null,
    recentCommentCompetitionMaterialsLoading: false,
    recentlyCommentedMaterials: null,
    recentlyCommentedMaterialsLoading: false,
  },
  getters: {
    featuredMaterials: (state) => state.featuredMaterials,
    featuredMaterialsLoading: (state) => state.featuredMaterialsLoading,
    topRatedMaterials: (state) => state.topRatedMaterials,
    topRatedMaterialsLoading: (state) => state.topRatedMaterialsLoading,
    mostVisitedMaterials: (state) => state.mostVisitedMaterials,
    mostVisitedMaterialsLoading: (state) => state.mostVisitedMaterialsLoading,
    mostCommentedMaterials: (state) => state.mostCommentedMaterials,
    mostCommentedMaterialsLoading: (state) => state.mostCommentedMaterialsLoading,
    latestMaterials: (state) => state.latestMaterials,
    latestMaterialsLoadingMore: (state) => state.latestMaterialsLoadingMore,
    latestMaterialsCurrentPage: (state) => state.latestMaterialsCurrentPage,
    latestMaterialsTotalPages: (state) => state.latestMaterialsTotalPages,
    latestMaterialsReachedTheEnd: (state) => state.latestMaterialsReachedTheEnd,
    recentCommentCompetitionMaterials: (state) => state.recentCommentCompetitionMaterials,
    recentCommentCompetitionMaterialsLoading: (state) => state.recentCommentCompetitionMaterialsLoading,
    recentlyCommentedMaterials: (state) => state.recentlyCommentedMaterials,
    recentlyCommentedMaterialsLoading: (state) => state.recentlyCommentedMaterialsLoading,
  },
  mutations: {
    getFeaturedMaterials: (state) => {
      state.featuredMaterialsLoading = true;
    },
    getFeaturedMaterialsSuccess: (state, payload) => {
      state.featuredMaterials = payload;
      state.featuredMaterialsLoading = false;
    },
    getFeaturedMaterialsFailure: (state) => {
      state.featuredMaterials = null;
      state.featuredMaterialsLoading = false;
    },
    getTopRatedMaterials: (state) => {
      state.topRatedMaterialsLoading = true;
    },
    getTopRatedMaterialsSuccess: (state, payload) => {
      state.topRatedMaterials = payload;
      state.topRatedMaterialsLoading = false;
    },
    getTopRatedMaterialsFailure: (state) => {
      state.topRatedMaterials = null;
      state.topRatedMaterialsLoading = false;
    },
    getMostVisitedMaterials: (state) => {
      state.mostVisitedMaterialsLoading = true;
    },
    getMostVisitedMaterialsSuccess: (state, payload) => {
      state.mostVisitedMaterials = payload;
      state.mostVisitedMaterialsLoading = false;
    },
    getMostVisitedMaterialsFailure: (state) => {
      state.mostVisitedMaterials = null;
      state.mostVisitedMaterialsLoading = false;
    },
    getMostCommentedMaterials: (state) => {
      state.mostCommentedMaterialsLoading = true;
    },
    getMostCommentedMaterialsSuccess: (state, payload) => {
      state.mostCommentedMaterials = payload;
      state.mostCommentedMaterialsLoading = false;
    },
    getMostCommentedMaterialsFailure: (state) => {
      state.mostCommentedMaterialsLoading = false;
    },
    getLatestMaterials: (state, payload) => {
      state.latestMaterialsLoadingMore = payload.loadingMore;
      if (state.latestMaterialsLoadingMore) {
        state.latestMaterialsCurrentPage += 1;
      } else {
        state.latestMaterials = [];
        state.latestMaterialsCurrentPage = 1;
      }
    },
    getLatestMaterialsSuccess: (state, payload) => {
      if (state.latestMaterialsLoadingMore) {
        state.latestMaterials = state.latestMaterials.concat(payload.data);
      } else {
        state.latestMaterials = payload.data;
        state.latestMaterialsTotalPages = Number(payload.headers['x-wp-totalpages']);
      }
      state.latestMaterialsReachedTheEnd = state.latestMaterialsCurrentPage === state.latestMaterialsTotalPages;
      state.latestMaterialsLoadingMore = false;
    },
    getLatestMaterialsFailure: (state, payload) => {
      state.latestMaterialsLoadingMore = false;
      state.latestMaterials = null;
      state.latestMaterialsError = payload;
    },
    getRecentCommentCompetitionMaterials: (state) => {
      state.recentCommentCompetitionMaterialsLoading = true;
    },
    getRecentCommentCompetitionMaterialsSuccess: (state, payload) => {
      state.recentCommentCompetitionMaterials = payload;
      state.recentCommentCompetitionMaterialsLoading = false;
    },
    getRecentCommentCompetitionMaterialsFailure: (state) => {
      state.recentCommentCompetitionMaterials = null;
      state.recentCommentCompetitionMaterialsLoading = false;
    },
    getRecentlyCommentedMaterials: (state) => {
      state.recentlyCommentedMaterialsLoading = true;
    },
    getRecentlyCommentedMaterialsSuccess: (state, payload) => {
      state.recentlyCommentedMaterials = payload;
      state.recentlyCommentedMaterialsLoading = false;
    },
    getRecentlyCommentedMaterialsFailure: (state) => {
      state.recentlyCommentedMaterials = null;
      state.recentlyCommentedMaterialsLoading = false;
    },
  },
  actions: {
    GET_FEATURED_MATERIALS: ({ commit }) => {
      commit('getFeaturedMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/featured_materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getFeaturedMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getFeaturedMaterialsFailure');
            reject();
          });
      });
    },
    GET_TOP_RATED_MATERIALS: ({ commit }) => {
      commit('getTopRatedMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/top_rated_materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getTopRatedMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getTopRatedMaterialsFailure');
            reject();
          });
      });
    },
    GET_MOST_VISITED_MATERIALS: ({ commit }) => {
      commit('getMostVisitedMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/most_visited_materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getMostVisitedMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getMostVisitedMaterialsFailure');
            reject();
          });
      });
    },
    GET_MOST_COMMENTED_MATERIALS: ({ commit }) => {
      commit('getMostCommentedMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/most_commented_materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getMostCommentedMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getMostCommentedMaterialsFailure');
            reject();
          });
      });
    },
    GET_LATEST_MATERIALS: ({ commit, getters }, payload) => {
      const { loadingMore } = payload;
      commit('getLatestMaterials', { loadingMore });
      const paginationParams = {
        page: getters.latestMaterialsCurrentPage,
        per_page: LATEST_MATERIALS_PER_PAGE,
      };
      const params = {
        lang: i18n.locale,
        ...paginationParams,
      };
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/latest_materials`, {
          params,
        })
          .then((response) => {
            commit('getLatestMaterialsSuccess', response);
            resolve();
          })
          .catch(() => {
            commit('getLatestMaterialsFailure');
            reject();
          });
      });
    },
    GET_RECENT_COMMENT_COMPETITION_MATERIALS: ({ commit }) => {
      commit('getRecentCommentCompetitionMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/recent_comment_competition_materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getRecentCommentCompetitionMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getRecentCommentCompetitionMaterialsFailure');
            reject();
          });
      });
    },
    GET_RECENTLY_COMMENTED_MATERIALS: ({ commit }) => {
      commit('getRecentlyCommentedMaterials');
      return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}/recently-commented-materials`, {
          params: { lang: i18n.locale },
        })
          .then(({ data }) => {
            commit('getRecentlyCommentedMaterialsSuccess', data);
            resolve();
          })
          .catch(() => {
            commit('getRecentlyCommentedMaterialsFailure');
            reject();
          });
      });
    },
  },
  namespaced: true,
};
